import axios from 'axios';

export const marcasApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/marcas`,
    headers: {
        'Content-Type': 'application/json'
    }
})